<template>
	<div class="layout-menu-container">
		<AppSubmenu :items="model" class="layout-menu" :root="isRoot"  @menuitem-click="onMenuItemClick" @keydown="onKeyDown" />
	</div>
</template>

<script>
import AppSubmenu from './AppSubmenu';

export default {
	props: {
		model: Array,
		isRoot:Boolean
	},
    methods: {
        onMenuItemClick(event) {
            this.$emit('menuitem-click', event);
        },
		onKeyDown(event) {
			const nodeElement = event.target;
			if (event.code === 'Enter' || event.code === 'Space') {
				nodeElement.click();
				event.preventDefault();
			}
		},
    },
	computed: {
		darkTheme() {
			return this.$appState.darkTheme;
		}
	},
	components: {
		'AppSubmenu': AppSubmenu
	}
}
</script>
<style>
.layout-menu li .layout-menuitem-root-text{
	font-size: 1.2rem;
	color:var(--surface-800);
	font-weight:540;
}
</style>